import React from 'react'
import PropTypes from 'prop-types'
import PortalModal from 'components/Shared/PortalModal'
import { Trans, useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'
import { useCampaignConfig, useCampaignConfigDispatch } from './CampaignConfigProvider'
import { localizeDateObj } from 'utils/helpers'

function PreviewContent({ isCampaignPaused }) {
  const { t } = useTranslation()
  const { campaign, form, dailyBudgetPreview } = useCampaignConfig()
  if (!dailyBudgetPreview) {
    return null
  }

  const formattedStartDate = localizeDateObj(form.start_date ?? campaign.start_date, 'de')
  const formattedEndDate = localizeDateObj(form.end_date ?? campaign.end_date, 'de')

  return (
    <div className="yes-no-prompt_content">
      <Trans
        i18nKey="Recommendations.campaignConfig.preview.description"
        values={{
          currency: campaign.currency,
          budget: form.total_budget || '-',
          startDate: formattedStartDate || '-',
          endDate: formattedEndDate || '-',
          dailyBudget: dailyBudgetPreview.new_daily_budget || '-',
        }}
      />
      {isCampaignPaused && (
        <div className="mt-3">
          {t('Recommendations.campaignConfig.preview.activationWarningPaused')}
        </div>
      )}
    </div>
  )
}

PreviewContent.propTypes = {
  isCampaignPaused: PropTypes.bool.isRequired,
}

export default function PreviewModal({ isCampaignPaused, onConfirm }) {
  const { t } = useTranslation()
  const { dailyBudgetPreview, loading } = useCampaignConfig()
  const { resetDailyBudgetPreview } = useCampaignConfigDispatch()
  const isOpen = !!dailyBudgetPreview
  const onCancel = () => resetDailyBudgetPreview()

  return (
    <PortalModal
      isOpen={isOpen}
      onClickOutside={onCancel}
      title={t('Recommendations.campaignConfig.preview.title')}
      className="cbr-modal cbr-modal--preview"
    >
      <div className="yes-no-prompt-prompt">
        <PreviewContent isCampaignPaused={isCampaignPaused} />
        <div className="yes-no-prompt_footer">
          <TransparentBgButton text={t('common.back')} onClick={onCancel} color="navy" light />
          <SecondaryButton className="bt" text={t('common.confirm')} onClick={onConfirm} disabled={loading} fullWidth={false} />
        </div>
      </div>
    </PortalModal>
  )
}

PreviewModal.propTypes = {
  isCampaignPaused: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
}
